module.exports = {
    NAME:"",
    EMAIL:"",
    PHONE:"",
    PHONE_VERIFIED:false,
    WATCHHISTORY:JSON.parse(localStorage.getItem("video_list")) || [],
    FAVOURITES:JSON.parse(localStorage.getItem("favourites")) || [],
    COUNTRY:"",
    UUID:"",
    SUB:false,
    SETTINGS:JSON.parse(localStorage.getItem("settings")) || {},


  };